export const wootricAccountToken = process.env.REACT_APP_WOOTRIC_ACCOUNT_TOKEN
export const wootricChatToken = process.env.REACT_APP_WOOTRIC_ACCOUNT_CHAT_TOKEN
